var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_6516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7312 37.1346C43.0444 33.0715 42.1033 27.9338 38.5 24.9546V19.2496H39.375C39.8582 19.2496 40.25 18.8578 40.25 18.3746V15.7496H41.1251C41.6083 15.7484 41.9991 15.3557 41.9979 14.8725C41.9973 14.5873 41.8577 14.3202 41.6237 14.1571L21.4987 0.157062C21.1988 -0.0510518 20.8012 -0.0510518 20.5012 0.157062L0.376277 14.1571C-0.0200156 14.4337 -0.116977 14.9791 0.159551 15.3754C0.322793 15.6093 0.589805 15.7489 0.875027 15.7496H1.75005V18.3746C1.75005 18.8578 2.14184 19.2496 2.62508 19.2496H3.50011V33.2496H2.625C2.14175 33.2496 1.74997 33.6414 1.74997 34.1246V36.9071C0.703746 37.277 0.00311719 38.2648 0 39.3746V41.1245C0 41.6078 0.391781 41.9996 0.875027 41.9996H41.1251C41.6083 41.9996 42.0001 41.6078 42.0001 41.1245V39.3746C41.9974 38.4575 41.5164 37.6083 40.7312 37.1346ZM38.5 17.4996H31.5V15.7496H38.5V17.4996ZM36.75 19.2496V23.8083C35.6594 23.2482 34.4711 22.9035 33.25 22.7933V19.2496H36.75ZM21 1.94206L38.3338 13.9996H3.66622L21 1.94206ZM11.375 33.2496H10.5V19.2496H11.375C11.8583 19.2496 12.2501 18.8578 12.2501 18.3746V15.7496H15.75V18.3746C15.75 18.8578 16.1418 19.2496 16.625 19.2496H17.5001V33.2496H16.625C16.1418 33.2496 15.75 33.6414 15.75 34.1246V36.7496H12.25V34.1246C12.25 33.6413 11.8583 33.2496 11.375 33.2496ZM17.5 34.9996H23.1263C23.2985 35.6042 23.53 36.1904 23.8175 36.7496H17.5001V34.9996H17.5ZM19.25 33.2496V19.2496H22.7501V33.2496H19.25ZM23.625 17.4996H17.5V15.7496H24.4999V17.4996H23.625ZM24.5 19.2496H25.3751C25.8583 19.2496 26.2501 18.8578 26.2501 18.3746V15.7496H29.7501V18.3746C29.7501 18.8578 30.1419 19.2496 30.6251 19.2496H31.5V22.7933C28.6835 23.0524 26.1234 24.5372 24.5 26.8533V19.2496ZM3.50003 15.7496H10.5V17.4995H3.50003V15.7496ZM8.75003 19.2496V33.2496H5.25V19.2496H8.75003ZM3.50003 34.9996H10.5V36.7496H3.50003V34.9996ZM1.74997 40.2496V39.3746C1.74997 38.8913 2.14175 38.4995 2.625 38.4995H24.955C25.5071 39.1648 26.1457 39.7534 26.8537 40.2495L1.74997 40.2496ZM40.25 40.2496H37.8875C38.5691 39.7736 39.1867 39.2119 39.725 38.5784C40.042 38.7167 40.2477 39.0288 40.25 39.3746V40.2496ZM32.375 40.2496C28.0258 40.2496 24.5 36.7238 24.5 32.3746C24.5 28.0254 28.0258 24.4996 32.375 24.4996C36.7242 24.4996 40.25 28.0254 40.25 32.3746C40.25 36.7238 36.7242 40.2496 32.375 40.2496Z",
    fill: "url(#paint0_linear_91_6516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.185 10.6655L21.5601 3.66553L20.4838 5.08303L27.93 10.4993H12.25V12.2493H30.625C31.0195 12.2686 31.378 12.0212 31.5 11.6455C31.6186 11.2851 31.4914 10.8893 31.185 10.6655Z",
    fill: "url(#paint1_linear_91_6516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.125 27.9992H33.25V26.2493H31.5V27.9992H30.625C29.6585 27.9992 28.875 28.7827 28.875 29.7492V31.4992C28.875 32.4657 29.6585 33.2492 30.625 33.2492H34.125V34.9991H30.625V34.1241H28.875V34.9991C28.875 35.9656 29.6585 36.7491 30.625 36.7491H31.5V38.4991H33.25V36.7491H34.125C35.0915 36.7491 35.875 35.9656 35.875 34.9991V33.2492C35.875 32.2827 35.0915 31.4992 34.125 31.4992H30.625V29.7492H34.125V30.6242H35.875V29.7492C35.875 28.7827 35.0915 27.9992 34.125 27.9992Z",
    fill: "url(#paint2_linear_91_6516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_6516",
    x1: 19.8772,
    y1: -45.8045,
    x2: 46.9822,
    y2: 23.6252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_6516",
    x1: 21.3812,
    y1: -5.69743,
    x2: 24.139,
    y2: 10.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_6516",
    x1: 32.1879,
    y1: 12.8891,
    x2: 43.058,
    y2: 28.7996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_6516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/Banking.a33e60bef410999fd75b5bc4858f6a1e.svg";
export { ForwardRef as ReactComponent };